import React, { useState } from 'react';
import classnames from 'classnames';
import { Checkbox, IdGen, Label, NumericInput, Pane, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import Model from "../model/StatsAggTextViewModel.js";
import S from '../Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.StatsAggTextViewEditor');
export default function StatsAggTextViewEditor(props) {
  const {
    value
  } = props;
  const [ids] = useState(IdGen.createIds('attr', 10));
  let idn = 0;
  const onModelChange = useValueChange(Model, props);
  const hLFont = ModelEditorFactory.create(Model.getHeaderLabelFont(value), {
    eventData: 'setHeaderLabelFont',
    onChange: onModelChange
  });
  const vLFont = ModelEditorFactory.create(Model.getValueLabelFont(value), {
    eventData: 'setValueLabelFont',
    onChange: onModelChange
  });
  const vTFont = ModelEditorFactory.create(Model.getValueTextFont(value), {
    eventData: 'setValueTextFont',
    onChange: onModelChange
  });
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "editor",
    className: classnames(S.grid, S.sub),
    children: [/*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: t('header')
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idn],
      children: t('label')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[idn++],
      eventData: "setHeaderLabel",
      onChange: onModelChange,
      value: Model.getHeaderLabel(value)
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idn],
      children: t('variant')
    }), /*#__PURE__*/_jsx(TextInput, {
      id: ids[idn++],
      eventData: "setVariant",
      onChange: onModelChange,
      value: Model.getVariant(value)
    }), hLFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: hLFont
    }), /*#__PURE__*/_jsx("h3", {
      className: S.fill,
      children: t('value')
    }), /*#__PURE__*/_jsx(Label, {
      children: t('label')
    }), vLFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: vLFont
    }), /*#__PURE__*/_jsx(Label, {
      children: t('text')
    }), vTFont != null && /*#__PURE__*/_jsx("div", {
      className: classnames(S.fill, S.sub),
      children: vTFont
    }), /*#__PURE__*/_jsx("div", {
      className: S.fill,
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: t('showX', {
          type: 'Count'
        }),
        onChange: onModelChange,
        eventData: "setShowCount",
        value: Model.getShowCount(value)
      })
    }), Model.getShowCount(value) && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        htmlFor: ids[idn],
        children: t('xLabel', {
          type: 'Count'
        })
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[idn++],
        eventData: "setCountValue",
        onChange: onModelChange,
        value: Model.getCountValue(value)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.fill,
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: t('showX', {
          type: 'Min.'
        }),
        onChange: onModelChange,
        eventData: "setShowMin",
        value: Model.getShowMin(value)
      })
    }), Model.getShowMin(value) && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        htmlFor: ids[idn],
        children: t('xLabel', {
          type: 'Min.'
        })
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[idn++],
        eventData: "setMinValue",
        onChange: onModelChange,
        value: Model.getMinValue(value)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.fill,
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: t('showX', {
          type: 'Max.'
        }),
        onChange: onModelChange,
        eventData: "setShowMax",
        value: Model.getShowMax(value)
      })
    }), Model.getShowMax(value) && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        htmlFor: ids[idn],
        children: t('xLabel', {
          type: 'Max.'
        })
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[idn++],
        eventData: "setMaxValue",
        onChange: onModelChange,
        value: Model.getMaxValue(value)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.fill,
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: t('showX', {
          type: 'Avg.'
        }),
        onChange: onModelChange,
        eventData: "setShowAvg",
        value: Model.getShowAvg(value)
      })
    }), Model.getShowAvg(value) && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        htmlFor: ids[idn],
        children: t('xLabel', {
          type: 'Avg.'
        })
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[idn++],
        eventData: "setAvgValue",
        onChange: onModelChange,
        value: Model.getAvgValue(value)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: S.fill,
      children: /*#__PURE__*/_jsx(Checkbox, {
        label: t('showX', {
          type: 'Sum.'
        }),
        onChange: onModelChange,
        eventData: "setShowSum",
        value: Model.getShowSum(value)
      })
    }), Model.getShowSum(value) && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Label, {
        htmlFor: ids[idn],
        children: t('xLabel', {
          type: 'Sum.'
        })
      }), /*#__PURE__*/_jsx(TextInput, {
        id: ids[idn++],
        eventData: "setSumValue",
        onChange: onModelChange,
        value: Model.getSumValue(value)
      })]
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idn],
      children: t('round')
    }), /*#__PURE__*/_jsx(NumericInput, {
      id: ids[idn++],
      eventData: "setRoundTo",
      onChange: onModelChange,
      value: Model.getRoundTo(value)
    })]
  });
}